"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const common_1 = require("@/emails/common");
exports.formSchema = zod_1.default.object({
    senderName: zod_1.default
        .string()
        .min(1, { message: 'Please enter a sender name' })
        .trim(),
    replyToEmail: zod_1.default
        .string()
        .email({ message: 'Please enter a valid email address' })
        .trim(),
    logoImageUrl: zod_1.default.string().optional(),
    logoWidth: zod_1.default.number(),
    logoTargetLink: common_1.optionalURLSchema,
    socials: zod_1.default
        .object({
        instagram: common_1.optionalURLSchema,
        x: common_1.optionalURLSchema,
        facebook: common_1.optionalURLSchema
    })
        .optional(),
    colors: zod_1.default
        .object({
        accent: zod_1.default.string().trim().toLowerCase(),
        background: zod_1.default.string().trim().toLowerCase(),
        buttonText: zod_1.default.string().trim().toLowerCase(),
        text: zod_1.default.string().trim().toLowerCase()
    })
        .optional(),
    address: zod_1.default.object({
        addressLine1: zod_1.default
            .string()
            .trim()
            .min(1, { message: 'Please enter an address' }),
        addressLine2: zod_1.default.string().trim().optional(),
        city: zod_1.default.string().trim().min(1, { message: 'Please enter a city' }),
        state: zod_1.default
            .string()
            .trim()
            .min(1, { message: 'Please enter a state/province' }),
        zip: zod_1.default.string().trim().min(1, { message: 'Please enter a postal code' }),
        country: zod_1.default.string().trim().min(1, { message: 'Please enter a country' })
    })
});
